/* the custom useFields reducer hook for managing form state */
import { useActionData, useLoaderData, useSubmit } from "@remix-run/react";
import React, { useEffect, useReducer } from "react";

import { TypedResponse } from "@remix-run/deno";
import { hashSum } from "../deps/hash-sum.ts";
import { FieldsManager } from "../lib/form-fields/manager.ts";
import { reducer } from "../lib/form-fields/reducer.ts";
import { Fieldset } from "../lib/form-fields/types.ts";

export * from "../lib/form-fields.ts";

export type FormFieldsLoaderFunction = (
  ..._: any[]
) => Promise<TypedResponse<{ formFields: Fieldset }>>;

export type FormFieldsActionFunction = (
  ..._: any[]
) => Promise<TypedResponse<{ fields: Fieldset }>>;

export function useFields<
  T extends Fieldset,
>() {
  const loaderData = useLoaderData<FormFieldsLoaderFunction>();
  const actionData = useActionData<FormFieldsActionFunction>();
  const [state, dispatch] = useReducer(reducer<T>, loaderData.formFields as T);

  const submit = useSubmit();

  useEffect(() => {
    // console.log(JSON.stringify(state));
  }, []);

  useEffect(() => {
    if (actionData) {
      dispatch({
        type: "markAsSubmitted",
        actionData: actionData.fields as T,
      });
    }
  }, [hashSum(actionData)]);

  const fm = new FieldsManager(state, dispatch, submit);
  return fm;
}
